<template>
  <div>
    <!--日報一覧-->
    <BContainer fluid class="mt-3">
      <BRow>
        <BCol>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>レポート</h5>
            <div class="d-flex float-right">
            </div>
          </div>
        </BCol>
      </BRow>
      <BRow>
        <BCol>
          <BCard no-body class="shadow-sm">
            <BTabs card>
              <BTab active @click="setGarbageType('household')">
                <template #title>
                  <div class="text-dark">家庭ごみレポート</div>
                </template>
                <div class="d-flex">

                  <!-- 左側のナビゲーションリスト -->
                  <ul class="nav nav-pills flex-column" style="border-right: 1px solid #dee2e6; min-width: 150px;">
                    <li class="nav-item">
                      <!-- 「日報」ボタン (アクティブ状態) -->
                      <a class="nav-link active" href="#">
                        <div class="text-dark">日報</div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <!-- 「集計」ボタン -->
                      <a class="nav-link" href="#" @click.prevent="navigateToSummary">
                        <div class="text-dark">集計</div>
                      </a>
                    </li>
                  </ul>

                  <!-- 右側のコンテンツエリア -->
                  <div class="tab-content flex-grow-1 p-3">
                    <!-- 「日報」のコンテンツ -->
                    <div class="tab-pane active">
                      <BRow align-v="end">
                        <BCol>
                          <label for="household-datepicker">作業日開始</label>
                          <BFormInput id="household-datepicker-start" type="date" v-model="l_household_start_dateselected"
                            @input="initEditHouseHoldStartDate" />
                        </BCol>
                        <BCol>
                          <label for="household-datepicker">作業日終了</label>
                          <BFormInput id="household-datepicker-end" type="date" v-model="l_household_end_dateselected" />
                        </BCol>
                        <BCol>
                          <label for="household-company">企業</label>
                          <BFormSelect id="household-company" v-model="l_household_companyselected"
                            :options="l_household_companyoptions" placeholder="選択してください"
                            @change="handleHouseholdCompanySelected"></BFormSelect>
                        </BCol>
                        <BCol>
                          <label for="household-vehicle">車両番号</label>
                          <BFormSelect id="household-vehicle" v-model="l_household_vehicleselected"
                            :options="l_household_vehicleoptions" placeholder="選択してください"></BFormSelect>
                        </BCol>
                        <BCol>
                          <label for="household-route">ルートID</label>
                          <BFormInput id="household-route" v-model="l_household_routeselected"></BFormInput>
                        </BCol>
                        <BCol>
                          <BButton v-if="!l_reportListSearchRequestOfHousehold" class="w-100 aligh-middle"
                            variant="info" :disabled="l_updateHouseholdIndex.length != 0"
                            @click="getHouseholdDailyReportWorkRequestWrapper">検索</BButton>
                          <BButton v-else class="w-100 aligh-middle" variant="info" disabled><BSpinner
                              label="Spinning" small></BSpinner></BButton>
                        </BCol>
                      </BRow>
                      <BRow class="mt-2">
                        <BCol>
                          <BTable class="text-center" striped hover :items="l_householdReportTableData"
                            :fields="l_householdReportTableFields" :per-page="l_householdTableViewPerPage"
                            :current-page="l_householdTableViewCurrentPage">

                            <!-- (中略：b-tableのtemplate部分は変更なし) -->
                            <template #cell(編集)="row">
                              <BButton v-if="l_updateHouseholdIndex.includes(getHouseholdTableCurrentRow(row.index))"
                                size="sm" class="w-75 mr-2" variant="primary" disabled><BSpinner label="Spinning"
                                  small></BSpinner></BButton>
                              <BButton v-else-if="!row.item['稼働中']" size="sm" class="w-75 mr-2 text-dark"
                                variant="primary" @click="isCreateNew = false; getDailyReportDetailsWrapper(row)">
                                <i v-if="row.item['承認']" class="bi bi-eyeglasses mr-1" aria-label="Help"></i>
                                <i v-else class="bi bi-pencil-square mr-1" aria-label="Help"></i>
                                {{ (row.item['承認']) ? '確認' : '編集' }}
                              </BButton>
                              <BButton v-else size="sm" class="w-75 mr-2 text-dark" disabled variant="primary">
                                <i class="bi bi-truck mr-1" aria-label="Help"></i>作業中
                              </BButton>
                            </template>

                            <template #cell(削除)="row">
                              <BButton v-if="l_updateHouseholdIndex.includes(getHouseholdTableCurrentRow(row.index))"
                                size="sm" class="w-75 mr-2" variant="danger" disabled><BSpinner label="Spinning"
                                  small></BSpinner></BButton>
                              <BButton v-else-if="!row.item['稼働中']" size="sm" class="w-75 mr-2 text-white"
                                variant="danger"
                                :disabled="row.item['承認'] || l_updateHouseholdIndex.length != 0 || l_reportListSearchRequestOfHousehold"
                                @click="l_report_garbageType = 'household'; l_report_selectedIndex = getHouseholdTableCurrentRow(row.index); $refs.confirmProcessModal.show()">
                                <i class="bi bi-trash mr-1" aria-label="Help"></i>削除
                              </BButton>
                              <BButton v-else size="sm" class="w-75 mr-2 text-white" disabled variant="danger">
                                <i class="bi bi-truck mr-1" aria-label="Help"></i>作業中
                              </BButton>
                            </template>

                            <template #cell(承認)="row">
                              <BButton v-if="l_updateHouseholdIndex.includes(getHouseholdTableCurrentRow(row.index))"
                                size="sm" class="w-75 mr-2" :variant="row.item['承認'] ? 'secondary' : 'success'"
                                disabled><BSpinner label="Spinning" small></BSpinner></BButton>
                              <BButton v-else-if="!l_userClass || !row.item['稼働中']" size="sm"
                                class="w-75 mr-2 text-white" :variant="row.item['承認'] ? 'secondary' : 'success'"
                                @click="postHouseholdDailyReportWorkUpdateWrapper(getHouseholdTableCurrentRow(row.index))"
                                :disabled="!l_userClass || l_reportListSearchRequestOfHousehold">
                                {{ row.item['承認'] ? '承認済' : '未承認' }}
                              </BButton>
                              <BButton v-else size="sm" class="w-75 mr-2 text-white" disabled variant="success">
                                <i class="bi bi-truck mr-1" aria-label="Help"></i>作業中
                              </BButton>
                            </template>

                          </BTable>

                          <BRow>
                            <BCol>
                              <div class="d-flex flex-row">
                                <BPagination v-model="l_householdTableViewCurrentPage"
                                  :total-rows="getHouseholdTableRows" :per-page="l_householdTableViewPerPage"
                                  aria-controls="my-table">
                                  <template #page="{ page, active }">
                                    <b v-if="active">
                                      <div class="text-dark">{{ page }}</div>
                                    </b>
                                    <div v-else class="text-dark">{{ page }}</div>
                                  </template>
                                </BPagination>
                                <BButton variant="light" class="ml-2 h-100" disabled><b>検索結果合計 :
                                    {{ getHouseholdTableRows }}
                                    件</b></BButton>
                              </div>
                            </BCol>
                          </BRow>
                        </BCol>
                      </BRow>
                    </div>
                  </div>
                </div>
              </BTab>
            </BTabs>
          </BCard>
        </BCol>
      </BRow>

    </BContainer>
    <!--日報新規作成-->
    <BModal ref="CreateNewReportModal" no-close-on-esc no-close-on-backdrop>
      <template #header="{}">
        <h5>新規作成 {{ (l_createNew_selectd === 'household') ? '（家庭）' : '（資源）' }}</h5>
      </template>
      <BOverlay
        :show="l_createnewProcessing || (l_createNew_selectd != 'household' && l_getGarbageInformationProcessing)"
        spinner-variant="primary">
        <div>
          <BRow class="mt-2">
            <BCol>
              <label for="editsetting-date">作業日</label>
              <BFormInput id="editsetting-date" type="date" v-model="l_createNewReportIndex.date"
                :state='reportDateState' />
            </BCol>
          </BRow>
          <BRow class="mt-2">
            <BCol>
              <label for="editsetting-type">種別</label>
              <BFormSelect id="editsetting-type" v-if="l_createNew_selectd === 'household'" :state="typeState"
                disabled v-model="l_createNewReportIndex.garbageKindNo"
                :options="l_household_garbagekindnooptions_createNew"></BFormSelect>
            </BCol>
          </BRow>

          <BRow class="mt-2">
            <BCol>
              <label for="editsetting-company">企業</label>
              <BFormSelect id="editsetting-company" :state="companyState" v-model="l_createNewReportIndex.companyId"
                :options="l_household_companyoptions.slice(1,)" @change="handleCompanySelected">
              </BFormSelect>
            </BCol>
          </BRow>
          <BRow class="mt-2">
            <BCol>
              <label for="editsetting-vehicle">車両番号</label>
              <BFormSelect id="editsetting-vehicle" :state="vehicleNoState" v-model="l_createNewReportIndex.vehicleNo"
                :options="l_household_vehicleoptions_createNew.slice(1,)">
              </BFormSelect>
            </BCol>
          </BRow>
          <BRow class="mt-2">
            <BCol>
              <label for="editsetting-route">ルートID</label>
              <BFormInput id="editsetting-route" :state="routeIdState" placeholder="5桁の数字を入力してください"
                v-model="l_createNewReportIndex.routeId"></BFormInput>
              <BFormInvalidFeedback id="input-live-feedback" :state="routeIdState"
                v-for="(error, index) in l_routeError" :key="index">
                {{ error }}
              </BFormInvalidFeedback>
            </BCol>
          </BRow>
        </div>
      </BOverlay>
      <template #footer="{ ok, cancel }">
        <div>
          <BButton variant="primary"
            :disabled="!l_reportDateState || !l_companyState || !l_vehicleNoState || !l_typeState || !l_routeIdState || l_createnewProcessing"
            @click="isCreateNew = true; showEditReportModal()">
            作成する
          </BButton>
          <BButton variant="secondary" @click="cancel()">
            中止する
          </BButton>
        </div>
      </template>
    </BModal>


    <!--日報削除-->
    <BModal ref="confirmProcessModal" class="checkmodal" hide-header no-close-on-esc no-close-on-backdrop
      @hidden="l_deleteReportCompleted = false">
      <div v-if="!l_deleteReportCompleted">
        <h5 class="checkmodal">日報を削除します。削除した日報は元に戻せません。 よろしいですか？</h5>
      </div>
      <div v-else>
        <h5 class="checkmodal">日報の削除が完了しました。</h5>
      </div>

      <template #footer="{ ok, cancel }">
        <div>
          <p v-if="l_deleteReportProcessing" class="text-center"><BSpinner label="Spinning" variant="danger"
              small></BSpinner></p>

          <BButton v-show="!l_deleteReportCompleted" :disabled="l_deleteReportProcessing" variant="danger"
            @click="dailyReportDeleteWrapper(l_report_selectedIndex)">
            削除する
          </BButton>
          <BButton :disabled="l_deleteReportProcessing" variant="secondary"
            @click="$refs.confirmProcessModal.hide()">
            {{ (l_deleteReportCompleted) ? '閉じる' : 'いいえ(中止します)' }}
          </BButton>
        </div>
      </template>
    </BModal>

    <!--日報編集-->
    <BModal
      ref="editHouseholdModal"
      class="editmodal modal-size"
      size="xl"
      dialog-class="modal-xl modal-size"
      no-close-on-esc
      no-close-on-backdrop
      @hidden="initEditModalParameters()">
      <template #header="{}">
        <h5 class="editmodal">家庭ごみ日報の編集</h5>
      </template>
      <BOverlay :show="l_reportDetailsLoading || l_reportUnsavedAlert || l_reportOverrideAlert"
        spinner-variant="primary">
        <template #overlay>
          <div v-if="l_reportUnsavedAlert" class="text-center editmodal">
            <p>編集中のデータがある場合失われますがよろしいですか？</p>
            <BButton variant="danger" @click="$refs.editHouseholdModal.hide();">
              保存しないで閉じる
            </BButton>
            <BButton variant="secondary" @click="l_reportUnsavedAlert = false" class="ml-2">
              編集画面に戻る
            </BButton>
          </div>
          <div v-if="l_reportOverrideAlert" class="text-center editmodal">
            <div v-if="l_editHouseholdCompleted">
              <p>データの更新が完了しました。</p>
              <BButton variant="secondary" @click="$refs.editHouseholdModal.hide();" class="ml-2">
                ウインドウを閉じる
              </BButton>
            </div>
            <div v-else>
              <p v-if="l_editHouseholdProcessing"><BSpinner label="Spinning" variant="info"></BSpinner></p>
              <p v-else> {{ isCreateNew ? '日報を新規作成する' : 'データが上書きされますがよろしいですか？' }} </p>
              <BButton :disabled="l_editHouseholdProcessing" variant="info" @click="updateDailyReportDetailsWrapper()">
                {{ isCreateNew ? '新規作成する' : '上書きして保存する' }}
              </BButton>
              <BButton variant="secondary" :disabled="l_editHouseholdProcessing" @click="l_reportOverrideAlert = false"
                class="ml-2">
                編集画面に戻る
              </BButton>
            </div>
          </div>
        </template>

        <BOverlay :show="l_onlyBrowse" spinner-small spinner-variant="light" :opacity="0.2">
          <div class="editmodal">
            <BRow>
              <BCol>
                <BInputGroup prepend="日付">
                  <BFormInput v-model="l_reportDetailsData.collectionDate" disabled></BFormInput>
                </BInputGroup>
              </BCol>
              <BCol>
                <BInputGroup prepend="ごみ種別">
                  <BFormInput v-model="l_reportDetailsData.garbageCategory" disabled></BFormInput>
                </BInputGroup>
              </BCol>
            </BRow>
            <BRow>
              <BCol>
                <BInputGroup prepend="企業名">
                  <BFormInput v-model="l_reportDetailsData.company" disabled></BFormInput>
                </BInputGroup>
              </BCol>
              <BCol>
                <BInputGroup prepend="エリア番号">
                  <BFormInput v-model="l_reportDetailsData.areaNo" disabled></BFormInput>
                </BInputGroup>
              </BCol>
            </BRow>
            <BRow>
              <BCol>
                <BInputGroup prepend="車両番号">
                  <BFormInput v-model="l_reportDetailsData.targetNo" disabled></BFormInput>
                </BInputGroup>
              </BCol>
              <BCol>
                <BInputGroup prepend="運転手">
                  <BFormSelect v-model="l_reportDetailsData.driverName"
                    :options="getOperatorNameList(l_reportDetailsData.companyNumber)"></BFormSelect>
                </BInputGroup>
              </BCol>
            </BRow>
            <BRow>
              <BCol>
                <BInputGroup prepend="収集地区">
                  <BFormInput v-model="l_reportDetailsData.collectionArea" disabled></BFormInput>
                </BInputGroup>
              </BCol>
              <BCol>
                <BInputGroup prepend="作業員">
                  <BFormSelect v-model="l_reportDetailsData.operatorName[0]"
                    :options="getOperatorNameList(l_reportDetailsData.companyNumber)"></BFormSelect>
                  <BFormSelect v-model="l_reportDetailsData.operatorName[1]"
                    :options="getOperatorNameList(l_reportDetailsData.companyNumber)"></BFormSelect>
                </BInputGroup>
              </BCol>
            </BRow>
            <BRow class="mt-3">
              <BCol class="report-area">
                <BTable striped hover bordered outlined :fields="l_reportHouseholdDetailsFields"
                  :items="l_reportDetailsData.dirtObject" class="text-center report-table" foot-clone>

                  <template #thead-top>
                    <BTr>
                      <BTh></BTh>
                      <BTh colspan="6">収集</BTh>
                      <BTh colspan="2">ごみ捨て</BTh>
                      <BTh></BTh>
                    </BTr>
                  </template>

                  <template #cell(運行回)="dirtObject">
                    {{ dirtObject.item.index }}
                  </template>
                  <template #cell(開始)="dirtObject">
                    <BFormInput type="time"
                      v-model="dirtObject.item.collectionStartTime"
                      placeholder="未選択"
                      :state="collectionStartTimeState(dirtObject.index)"
                      @input="collectionStartTimeInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(終了)="dirtObject">
                    <BFormInput type="time"
                      v-model="dirtObject.item.collectionEndTime"
                      placeholder="未選択"
                      :state="collectionEndTimeState(dirtObject.index)"
                      @input="collectionEndTimeInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(収集時間)="dirtObject">
                    <BFormInput type="time" v-model="dirtObject.item.collectionTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #cell(停車時間)="dirtObject">
                    <BFormInput type="time" v-model="dirtObject.item.stopTime" placeholder="未選択"
                      disabled></BFormInput>
                  </template>
                  <template #cell(集積所)="dirtObject">
                    <BFormInput v-model="dirtObject.item.collectionPoints" type="number"
                      style="width:100px" :state="collectionPointsState(dirtObject.index)"
                      @input="collectionPointsInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(収集距離)="dirtObject">
                    <BFormInput v-model="dirtObject.item.collectionDistance" type="number"
                      style="width:125px" :state="collectionDistanceState(dirtObject.index)"
                      @input="collectionDistanceInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(ごみ捨て時間)="dirtObject">
                    <BFormInput type="time" v-model="dirtObject.item.travelTime"
                      placeholder="未選択"
                      :state="travelTimeState(dirtObject.index)"
                      @input="travelTimeInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(ごみ捨て距離)="dirtObject">
                    <BFormInput v-model="dirtObject.item.travelDistance" type="number"
                      style="width:100px" :state="travelDistanceState(dirtObject.index)"
                      @input="travelDistanceInput(dirtObject.index)"></BFormInput>
                  </template>
                  <template #cell(ごみ量)="dirtObject">
                    <BFormInput v-model="dirtObject.item.garbageWeight" type="number"
                      style="width:100px" :state="garbageWeightState(dirtObject.index)"
                      @input="garbageWeightInput(dirtObject.index)"></BFormInput>
                  </template>

                  <template #foot(運行回)>
                    小計
                  </template>
                  <template #foot(開始)>
                    <BFormInput type="time" :value="l_reportDetailsData.totalCollectionStartTime"
                      :state="l_reportDetailsData.totalCollectionStartTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #foot(終了)>
                    <BFormInput type="time" :value="l_reportDetailsData.totalCollectionEndTime"
                      :state="l_reportDetailsData.totalCollectionEndTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #foot(収集時間)>
                    <BFormInput type="time" v-model="l_reportDetailsData.totalCollectionTime"
                      :state="l_reportDetailsData.totalCollectionTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #foot(停車時間)>
                    <BFormInput type="time" v-model="l_reportDetailsData.totalStopTime"
                      :state="l_reportDetailsData.totalStopTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #foot(集積所)>
                    <BFormInput v-model="l_reportDetailsData.totalCollectionPoints"
                      style="width:100px" disabled></BFormInput>
                  </template>
                  <template #foot(収集距離)>
                    <BFormInput v-model="l_reportDetailsData.totalCollectionDistance"
                      style="width:125px" disabled></BFormInput>
                  </template>
                  <template #foot(ごみ捨て時間)>
                    <BFormInput type="time" v-model="l_reportDetailsData.totalTravelTime"
                      placeholder="未選択" disabled></BFormInput>
                  </template>
                  <template #foot(ごみ捨て距離)>
                    <BFormInput v-model="l_reportDetailsData.totalTravelDistance" style="width:100px"
                      disabled></BFormInput>
                  </template>
                  <template #foot(ごみ量)>
                    <BFormInput v-model="l_reportDetailsData.totalGarbageWeight" style="width:100px"
                      disabled></BFormInput>
                  </template>

                </BTable>
              </BCol>
            </BRow>
            <BRow class="mb-2">
              <BCol class="font-weight-bold">再収集回数</BCol>
              <BCol class="font-weight-bold">ODO運行前（km）</BCol>
              <BCol class="font-weight-bold">ODO運行後（km）</BCol>
              <BCol class="font-weight-bold">給油量（l）</BCol>
            </BRow>
            <BRow>
              <BCol>
                <BFormInput
                  v-model="l_reportDetailsData.recollections"
                  :state="recollectionsState()"
                  type="number"
                  placeholder="再収集回数"
                  @input="recollectionsInput">
                </BFormInput>
              </BCol>
              <BCol>
                <BFormInput
                  v-model="l_reportDetailsData.beforeServiceOdometer"
                  :state="beforeServiceOdometerState()"
                  type="number"
                  placeholder="ODO運行前（km）"
                  @input="beforeServiceOdometerInput">
                </BFormInput>
              </BCol>
              <BCol>
                <BFormInput
                  v-model="l_reportDetailsData.afterServiceOdometer"
                  :state="afterServiceOdometerState()"
                  type="number"
                  placeholder="ODO運行後（km）"
                  @input="afterServiceOdometerInput">
                </BFormInput>
              </BCol>
              <BCol>
                <BFormInput
                  v-model="l_reportDetailsData.refuelingAmount"
                  :state="refuelingAmountState()"
                  type="number"
                  placeholder="給油量（l）"
                  @input="refuelingAmountInput">
                </BFormInput>
              </BCol>
            </BRow>
          </div>

        </BOverlay>
      </BOverlay>

      <template #footer="{ ok, cancel }">
        <BAlert :show="!l_reportUpdateAvailability && !l_reportDetailsLoading" variant="danger"
          class="editmodal d-flex">
          <h5 class="ml-1 mr-1">
            <div>
              <BBadge v-for="view in l_totalValidationView" :key=view.id variant="danger" style="margin: 1px;">{{ view }}</BBadge>
            </div>
          </h5>
          を正しく設定してください
        </BAlert>
        <BButton v-show="!l_onlyBrowse"
          :disabled="!l_reportUpdateAvailability || l_reportUnsavedAlert || l_reportOverrideAlert || l_reportDetailsLoading"
          class="editmodal" variant="info" @click="l_reportOverrideAlert = true">
          {{ isCreateNew ? '作成する' : '更新する' }}
        </BButton>
        <BButton v-if="!l_onlyBrowse" :disabled="l_reportUnsavedAlert || l_reportOverrideAlert" class="editmodal"
          variant="secondary" @click="handleCancelClick">
          いいえ(中止します)
        </BButton>
        <BButton v-else :disabled="l_reportUnsavedAlert || l_reportOverrideAlert" class="editmodal" variant="secondary"
          @click="cancel()">
          閉じる
        </BButton>
      </template>
    </BModal>

  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment"
import BarHouseholdServiceTime from '../modules/chart/BarHouseholdServiceTime.vue'
import BarHouseholdServiceDist from '../modules/chart/BarHouseholdServiceDistance.vue';
import BarRecycleServiceTime from '../modules/chart/BarRecycleServiceTime.vue'
import BarRecycleServiceDist from '../modules/chart/BarRecycleServiceDistance.vue';

export default {
  components: { BarHouseholdServiceTime, BarHouseholdServiceDist, BarRecycleServiceTime, BarRecycleServiceDist },

  data() {
    return {

      /*ページ内定数 */
      //運行情報数
      SERVICE_COUNT_CHAR: "-",
      REPORT_DETALE_COUNT: 6,
      MAX_GARBAGE_WEIGHT: 9999,

      /*ページ内変数*/
      // ページマウント時に設定
      l_userClass: false,

      // 検索中フラグ
      l_reportListSearchRequestOfHousehold: false,

      l_onlyBrowse: false,

      //削除中フラグ
      l_deleteReportProcessing: false,

      //削除完了フラグ
      l_deleteReportCompleted: false,

      l_updateHouseholdIndex: [],
      l_report_garbageType: "",
      l_report_selectedIndex: 0,

      isCreateNew: false,
      l_getGarbageInformationProcessing: false,
      l_reportDateState: false,
      l_companyState: false,
      l_typeState: false,
      l_vehicleNoState: false,
      l_routeIdState: false,
      l_createRouteId: "",
      l_createnewProcessing: false,
      l_createNew_selectd: "",
      l_routeError: [],

      l_household_garbagekindnooptions_createNew: [
        { value: '0', text: '家庭ごみ' }
      ],
      l_household_vehicleoptions_createNew: [],

      l_householdReportTableData_createNew_LENGTH: 0,
      l_createNewReportIndex: {},
      l_createNewReportIndex_Original: {
        dataNo: "",
        date: "",
        companyId: "",
        companyName: "",
        garbageKindNo: "",
        vehicleNo: "",
        routeId: ""
      },

      l_overlay_household_dailysummary: false,

      l_household_start_dateselected: "",
      l_household_end_dateselected: "",
      l_household_vehicleselected: "",
      l_household_vehicleoptions: [
        { value: '', text: 'すべて', companyid: "-" },
        { value: '8298', text: '8298', companyid: '0' },
        { value: '5839', text: '5839', companyid: '0' },
        { value: '593', text: '593', companyid: '0' },
        { value: '594', text: '594', companyid: '0' },
        { value: '922', text: '922', companyid: '0' },
        { value: '923', text: '923', companyid: '0' },
        { value: '01', text: '01', companyid: '1' },
        { value: '02', text: '02', companyid: '1' },
        { value: '03', text: '03', companyid: '1' },
        { value: '04', text: '04', companyid: '1' },
        { value: '05', text: '05', companyid: '1' },
        { value: '06', text: '06', companyid: '1' },
        { value: '07', text: '07', companyid: '1' },
        { value: '08', text: '08', companyid: '1' },
        { value: '09', text: '09', companyid: '1' },
        { value: '10', text: '10', companyid: '1' },
        { value: '11', text: '11', companyid: '1' },
        { value: '12', text: '12', companyid: '1' },
        { value: '13', text: '13', companyid: '1' },
        { value: '14', text: '14', companyid: '1' },
        { value: '15', text: '15', companyid: '1' },
        { value: '16', text: '16', companyid: '1' },
        { value: '17', text: '17', companyid: '1' },
        { value: '18', text: '18', companyid: '1' },
        { value: '19', text: '19', companyid: '1' },
        { value: '20', text: '20', companyid: '1' },
        { value: '21', text: '21', companyid: '1' },
        { value: '22', text: '22', companyid: '1' },
        { value: '23', text: '23', companyid: '1' },
        { value: '24', text: '24', companyid: '1' },
        { value: '25', text: '25', companyid: '1' },
        { value: '26', text: '26', companyid: '1' },
        { value: '27', text: '27', companyid: '1' },
        { value: '28', text: '28', companyid: '1' },
        { value: '29', text: '29', companyid: '1' },
        { value: '30', text: '30', companyid: '1' },
        { value: '31', text: '31', companyid: '1' },
        { value: '32', text: '32', companyid: '1' },
        { value: '33', text: '33', companyid: '1' },
        { value: '34', text: '34', companyid: '1' },
        { value: '35', text: '35', companyid: '1' },
        { value: '36', text: '36', companyid: '1' },
        { value: '37', text: '37', companyid: '1' },
        { value: '38', text: '38', companyid: '1' },
        { value: '39', text: '39', companyid: '1' },
        { value: '40', text: '40', companyid: '1' },
      ],
      l_household_companyselected: "0",
      l_household_companyoptions: [],
      l_household_companyIDs: [],
      l_household_routeselected: "",
      l_household_routeoptions: [
        { value: '00000', text: '00000' },
      ],
      l_householdTableViewPerPage: 10,
      l_householdTableViewCurrentPage: 1,
      l_householdReportTableData: [],
      l_householdReportTableFields: ['作業日', '企業名', '車両番号', 'ルートID', '編集', '削除', '承認'],

      l_management_companyIDs: [],

      /*Report情報*/
      //Report情報
      l_reportDetailsData: {
        dataType: "",
        dataNo: "",
        collectionDate: "",
        garbageCategory: "",
        companyNumber:null,
        company: "",
        createAt:"",
        lastModifiedAt:"",
        areaNo: "",
        targetNo: "",
        driverName: "",
        collectionArea:"",
        operatorName: ["", ""],
        dirtObject: [],
        totalCollectionStartTime: "",
        totalCollectionEndTime: "",
        totalCollectionTime: "",
        totalStopTime: "",
        totalCollectionPoints: null,
        totalCollectionDistance: null,
        totalTravelTime: "",
        totalTravelDistance: null,
        totalGarbageWeight: null,
        recollections:null,
        routeId: "",
        beforeServiceOdometer: null,
        afterServiceOdometer: null,
        refuelingAmount: null,
      },
      //Report変更情報
      l_reportDetailsDataComp: {
        dataType: "",
        dataNo: "",
        collectionDate: "",
        garbageCategory: "",
        companyNumber:null,
        company: "",
        createAt:"",
        lastModifiedAt:"",
        areaNo: "",
        targetNo: "",
        driverName: "",
        collectionArea:"",
        operatorName: ["", ""],
        dirtObject: [],
        totalCollectionStartTime: "",
        totalCollectionEndTime: "",
        totalCollectionTime: "",
        totalStopTime: "",
        totalCollectionPoints: null,
        totalCollectionDistance: null,
        totalTravelTime: "",
        totalTravelDistance: null,
        totalGarbageWeight: null,
        recollections:null,
        routeId: "",
        beforeServiceOdometer: null,
        afterServiceOdometer: null,
        refuelingAmount: null,
      },
      l_reportHouseholdDetailsFields: ['運行回', '開始', '終了',
        { key: '収集時間', label: '時間' }, '停車時間', '集積所', { key: '収集距離', label: '距離(km)' },
        { key: 'ごみ捨て時間', label: '時間' }, { key: 'ごみ捨て距離', label: '距離(km)' }, 'ごみ量'],
      l_reportDetailsLoading: false,

      l_editHouseholdProcessing: false,
      l_editHouseholdCompleted: false,

      l_reportUnsavedAlert: false,
      l_reportOverrideAlert: false,

      l_householdCommentData: "",

      /*運行情報のバリデーションチェック初期値*/
      //開始
      l_collectionStartTimeValidation: [],
      //終了
      l_collectionEndTimeValidation: [],
      //集積所
      l_collectionPointsValidation: [],
      //収集距離
      l_collectionDistanceValidation: [],
      //ごみ捨て時間
      l_travelTimeValidation: [],
      //ごみ捨て距離
      l_travelDistanceValidation: [],
      //ごみ量
      l_garbageWeightValidation: [],
      //再収集回数
      l_recollectionsValidation:true,
      //ODO運行前
      l_beforeServiceOdometerValidation:true,
      //ODO運行後
      l_afterServiceOdometerValidation:true,
      //給油量
      l_refuelingAmountValidation:true,
      //ヴァリデーションエラー表示用
      l_totalValidationView:[],
      // 更新可能状態
      l_reportUpdateAvailability:true
    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
    this.l_management_companyIDs = this.getReportManagementCompanyOptions().map(e => e.value)
    this.l_userClass = this.l_management_companyIDs.includes(this.$store.getters.userAttributes['custom:company'])

    this.l_household_companyoptions = this.getReportHouseholdCompanyOptions()
    this.l_household_companyIDs = this.getReportHouseholdCompanyOptions().slice(1,).map(e => e.value)
    this.l_household_start_dateselected = moment().format('YYYY-MM-DD');
    this.l_household_end_dateselected = moment().format('YYYY-MM-DD');

    this.getHouseholdDailyReportWorkRequestWrapper()

    /*機能蓋閉じ用変更*/
    var hostStrings = window.location.host
    var envRegion = this.getCurrntEnvAndRegionFromURL(hostStrings)

    if (envRegion.env == "プレ運用環境") {
      this.isClosing = true
      this.closingColor = "text-black-50"
    } else {
      this.isClosing = false
      this.closingColor = "text-dark"
    }
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    getHouseholdTableRows() {
      return this.l_householdReportTableData.length
    },
    // NEW-68 state
    reportDateState() {
      let checkDate = new Date(this.l_createNewReportIndex.date)
      this.l_reportDateState = !(
        checkDate.getDay() == 0 ||
        checkDate.getDay() == 6 ||
        (checkDate.getDay() == 3 && checkDate.getDate() > 21 && this.l_createNewReportIndex.garbageKindNo == "0")
      )

      let dayInformation = ((this.l_createNewReportIndex.garbageKindNo == undefined) || (this.l_createNewReportIndex.garbageKindNo == ""))
        ? { garbagedayType: '0' } : this.getGarbagedayType(this.l_createNewReportIndex.garbageKindNo, this.l_createNewReportIndex.date)
      this.l_reportDateState = this.l_reportDateState && (dayInformation['garbagedayType'] != '999')
      this.createRouteId()
      return this.l_reportDateState
    },
    companyState() {
      this.l_companyState = (this.l_createNewReportIndex.companyId !== undefined && this.l_createNewReportIndex.companyId !== '')
      this.createRouteId()
      return this.l_companyState
    },
    vehicleNoState() {
      var ret = (this.l_createNewReportIndex.vehicleNo !== undefined && this.l_createNewReportIndex.vehicleNo !== '')
      if (ret && (this.l_createNewReportIndex.companyId !== undefined && this.l_createNewReportIndex.companyId !== "")) {
        const options = (this.l_createNew_selectd === 'household') ? this.getHouseReportVehicleOptions([this.l_createNewReportIndex.companyId]) :
          this.getRecycleReportVehicleOptions([this.l_createNewReportIndex.companyId]);
        const carNoArr = options.map(e => e.value)
        ret = carNoArr.includes(this.l_createNewReportIndex.vehicleNo)
      }
      this.l_vehicleNoState = ret
      return this.l_vehicleNoState
    },
    typeState() {
      this.l_typeState = (this.l_createNewReportIndex.garbageKindNo !== undefined && this.l_createNewReportIndex.garbageKindNo !== '')

      let dayInformation = (this.l_createNewReportIndex.garbageKindNo == '0') ? { garbagedayType: '0' } : this.getGarbagedayType(this.l_createNewReportIndex.garbageKindNo, this.l_createNewReportIndex.date)
      this.l_typeState = this.l_typeState && (dayInformation['garbagedayType'] != '999')
      this.createRouteId()
      return this.l_typeState
    },
    routeIdState() {
      this.l_routeIdState = this.digitValidation && this.routeValidation

      this.l_routeError = []
      if (!this.digitValidation) {
        this.l_routeError.push("５桁の数字で入力してください")
      }

      if (!this.routeValidation) {
        this.l_routeError.push("ルートIDが不正です。正しいルートIDを入力してください。")
      }

      return this.l_routeIdState
    },
    digitValidation() {
      const regex = new RegExp(/^[0-9]{4}[1-9]$/);
      return regex.test(this.l_createNewReportIndex.routeId)
    },
    routeValidation() {
      return this.l_createNewReportIndex.routeId.slice(0, 4) == this.l_createRouteId
    }
  },
  watch: {

  },
  methods: {
    sum(arr) {
      return arr.reduce((s, e) => s + e)
    },
    convertToGengo(seireki) {
      return parseInt(seireki) - 2018
    },
    getGengoOptions() {
      let yearOptions = this.getYearOptions()
      for (let i = 0; i < yearOptions.length; i++) {
        yearOptions[i]['text'] = 'R' + String(this.convertToGengo(yearOptions[i]['text'])) + '年度'
      }
      yearOptions.unshift({ value: null, text: '年度を選択して下さい' })
      return yearOptions
    },
    setGarbageType(type) {
      this.l_garbageType = type
    },
    getCompanies(garbagetype) {
      let option = (garbagetype == 'household') ? this.getReportHouseholdCompanyOptions() : this.getReportRecycleCompanyOptions()
      let includeAll = false
      option.forEach(e => {
        if (e.text == 'すべて') includeAll = true
      })

      let companies = {}
      option.forEach(e => {
        if (e.text != 'すべて') {
          let key = (includeAll) ? String(parseInt(e.value) - 1) : e.value
          companies[key] = e.text
        }
      })
      return companies
    },
    createRouteId() {
      if (this.l_reportDateState && this.l_companyState && this.l_vehicleNoState && this.l_typeState) {
        let companyId = this.l_createNewReportIndex.companyId
        let day = new Date(this.l_createNewReportIndex.date).getDay()
        let garbagedayType = this.getGarbagedayType(this.l_createNewReportIndex.garbageKindNo, this.l_createNewReportIndex.date)['garbagedayType']
        let recycleType = (this.l_createNewReportIndex.garbageKindNo == '0') ? '0' :
          (this.l_createNewReportIndex.garbageKindNo == '1') ? '0' : '1'
        this.l_createRouteId = String(companyId - 1) + String(day - 1) + garbagedayType + recycleType
      } else {
        this.l_createRouteId = ""
      }
      this.l_createNewReportIndex.routeId = this.l_createRouteId
    },
    getHouseholdTableCurrentRow(rowindex) {
      return (this.l_householdTableViewCurrentPage - 1) * this.l_householdTableViewPerPage + rowindex
    },
    initReportDetails() {
      //Report情報の初期化
      this.l_reportDetailsData = {
        dataType: "",
        dataNo: "",
        collectionDate: "",
        garbageCategory: "",
        companyNumber: null,
        company: "",
        createAt:"",
        lastModifiedAt:"",
        areaNo: "",
        targetNo: "",
        driverName: "",
        collectionArea:"",
        operatorName: ["", ""],
        dirtObject: [],
        totalCollectionStartTime: "",
        totalCollectionEndTime: "",
        totalCollectionTime: "",
        totalStopTime: "",
        totalCollectionPoints: null,
        totalCollectionDistance: null,
        totalTravelTime: "",
        totalTravelDistance: null,
        totalGarbageWeight: null,
        recollections:null,
        routeId: "",
        beforeServiceOdometer: null,
        afterServiceOdometer: null,
        refuelingAmount: null,
      },
      //開始
      this.l_collectionStartTimeValidation = []
      //終了
      this.l_collectionEndTimeValidation = []
      //集積所
      this.l_collectionPointsValidation = []
      //収集距離
      this.l_collectionDistanceValidation = []
      //ごみ捨て時間
      this.l_travelTimeValidation = []
      //ごみ捨て距離
      this.l_travelDistanceValidation = []
      //ごみ量
      this.l_garbageWeightValidation = []
      //再収集回数
      this.l_recollectionsValidation = true
      //ODO運行前
      this.l_beforeServiceOdometerValidation = true
      //ODO運行後
      this.l_afterServiceOdometerValidation = true
      //給油量
      this.l_refuelingAmountValidation = true
      //ヴァリデーションエラー表示用
      this.l_totalValidationView = []
      // 更新可能状態
      this.l_reportUpdateAvailability = true

    },
    isActiveVehicle(date, companyname, vehicleid, routeid) {
      var ret = false
      var vehicles = this.$store.getters.vehicleData.vehicleStatus
      for (var i in vehicles) {
        // last_updateはUTC時間として取得している
        var v_data_utc = vehicles[i]['last-update']
        //        var v_data_utc = new Date(v_data_utc.replace('/', '-') + 'Z').toISOString();
        // last_updateをUTC時間からJST時間に変換
        var v_date_jst = moment.utc(v_data_utc).local().format('YYYY/MM/DD HH:mm:ss')
        var v_date = v_date_jst.split(' ')[0]
        var v_routeId = vehicles[i].routeId
        var v_vehicleId = vehicles[i].vehicleId
        var v_companyName = vehicles[i].companyName
        if ((v_date == date) && (v_companyName == companyname) && (v_vehicleId == vehicleid) && (v_routeId == routeid)) {
          if (vehicles[i].CollectOperationStatus == 0) {
            ret = true // Active
          } else {
            ret = false // In Active
          }
          break;
        }
      }

      return ret
    },
    getDecimalPlaces(number) {
      if (typeof number !== 'number') {
        return null;
      }
      var decimalPlaces = 0;
      var parts = String(number).split('.');
      if (parts[1]) {
        decimalPlaces = parts[1].length;
      }
      return decimalPlaces
    },
    getMsFormatFromHourMin(hourmin) {
      return (Number(hourmin.split(":")[0]) * 3600 + Number(hourmin.split(":")[1]) * 60) * 1000
    },
    getHourMinFormatFromMs(ms) {
      if (ms >= 0) {
        return String(Math.floor(ms / 1000 / 60 / 60) % 24).padStart(2, '0') + ":" +
              String(Math.floor(ms / 1000 / 60) % 60).padStart(2, '0');
      } else {
        return "";
      }
    },
    storeReportDetails(data_list) {
      this.initReportDetails();

      var report = data_list['report']
      // 収集情報オブジェクト配列
      var collectionInfo = report['collectionInfo']

      /*小計まとめ*/
      // 開始時間
      var totalCollectionStartTimeFormatted= "00:00"

      // 終了時間
      var totalCollectionEndTimeFormatted= "00:00"

      // 収集時間
      var totalCollectionTimeMs = 0
      var totalCollectionTimeFormatted = "00:00"

      // 停車時間
      var totalStopTimeMs = 0
      var totalStopTimeFormatted = "00:00"

      // 集積所数
      var totalCollectionPoints = 0

      // 収集距離
      var totalCollectionDistance = 0

      // ごみ捨て時間
      var totalTravelTimeMs = 0
      var totalTravelTimeFormatted = "00:00"

      // ごみ捨て距離
      var totalTravelDistance = 0

      // ごみ量
      var totalGarbageWeight = null

      // 日報各運行情報まとめ
      var dirtObject_tmp=[]

      //運行の最後の運行指標
      var last_serviceCounts = 0

      //日報各運行情報の形成
      //DynamoDBに登録されている運行情報は1件以上 かつ　画面に表示する運行情報は6件固定のため、
      //6件迄取得 or DynamoDBに登録されている件数迄取得
      for (let i = 0; i < collectionInfo.length; i++) {
        //　運行回
        var index = Number(i) + 1
        if ("serviceCounts" in collectionInfo[i]) {
          last_serviceCounts = Number(collectionInfo[i].serviceCounts)
          if (collectionInfo[i].serviceCountsSub == "0") {
            index = collectionInfo[i].serviceCounts
          } else {
            index = collectionInfo[i].serviceCounts + this.SERVICE_COUNT_CHAR + collectionInfo[i].serviceCountsSub
          }
        } else {
          last_serviceCounts = Number(index)
        }

        // 収集開始
        var collectionStartTimeFormatted = ""
        if (collectionInfo[i].collectionStartTime != "" && collectionInfo[i].collectionStartTime != null) {
          collectionStartTimeFormatted = moment.utc(collectionInfo[i].collectionStartTime).utcOffset(9).format("HH:mm");
          if (i == 0) {
            totalCollectionStartTimeFormatted = collectionStartTimeFormatted
          }
        }

        // 収集終了
        var collectionEndTimeFormatted = ""
        if (collectionInfo[i].collectionEndTime != "" && collectionInfo[i].collectionEndTime != null) {
          collectionEndTimeFormatted = moment.utc(collectionInfo[i].collectionEndTime).utcOffset(9).format("HH:mm");
          totalCollectionEndTimeFormatted = collectionEndTimeFormatted
        }

        // 収集時間
        var collectionTimeMs = 0
        var collectionTimeFormatted = "00:00"
        if (collectionInfo[i].collectionTime != "" && collectionInfo[i].collectionTime != "") {
          collectionTimeMs = moment(collectionInfo[i].collectionTime, 'HH:mm').diff(moment(collectionTimeFormatted, 'HH:mm'))
          collectionTimeFormatted = this.getHourMinFormatFromMs(collectionTimeMs)
          totalCollectionTimeMs = totalCollectionTimeMs + collectionTimeMs
        }

        // 停車時間
        var stopTimeMs = 0
        var stopTimeFormatted = "00:00"
        if (collectionInfo[i].stopTime != "" && collectionInfo[i].stopTime != null) {
          stopTimeMs = moment(collectionInfo[i].stopTime, 'HH:mm').diff(moment(stopTimeFormatted, 'HH:mm'))
          totalStopTimeMs = totalStopTimeMs + stopTimeMs
          stopTimeFormatted = this.getHourMinFormatFromMs(stopTimeMs)
        }

        // 収集集積所
        var collectionPoints = 0
        if (collectionInfo[i].collectionPoints != null) {
          collectionPoints = Number(collectionInfo[i].collectionPoints);
        }
        totalCollectionPoints = totalCollectionPoints + collectionPoints

        // 収集距離
        var collectionDistance = 0.000
        if (collectionInfo[i].collectionDistance != null) {
          collectionDistance = Math.round(collectionInfo[i].collectionDistance * 1000) / 1000;

        }
        totalCollectionDistance = totalCollectionDistance + collectionDistance

        // ごみ捨て時間
        var travelTimeMs = 0
        var travelTimeFormatted = "00:00"
        if (collectionInfo[i].travelTime != "" && collectionInfo[i].travelTime != null) {
          travelTimeMs = moment(collectionInfo[i].travelTime, 'HH:mm').diff(moment(stopTimeFormatted, 'HH:mm'))
          totalTravelTimeMs = totalTravelTimeMs + travelTimeMs
        }
        travelTimeFormatted = this.getHourMinFormatFromMs(travelTimeMs)

        // ごみ捨て距離
        var travelDistance = 0.000
        if (collectionInfo[i].travelDistance != null) {
          travelDistance = Math.round(collectionInfo[i].travelDistance * 1000) / 1000;
        }
        totalTravelDistance = totalTravelDistance + travelDistance

        // ごみ量
        var garbageWeight = null
        if (collectionInfo[i].garbageWeight != null) {
          garbageWeight = Number(collectionInfo[i].garbageWeight);
        }
        totalGarbageWeight = totalGarbageWeight + garbageWeight

        // 日報各運行情報まとめ
        dirtObject_tmp.push({
          index: index,
          collectionStartTime: collectionStartTimeFormatted,
          collectionEndTime: collectionEndTimeFormatted,
          collectionTime: collectionTimeFormatted,
          stopTime: stopTimeFormatted,
          collectionPoints: collectionPoints,
          collectionDistance: collectionDistance,
          travelTime: travelTimeFormatted,
          travelDistance: travelDistance,
          garbageWeight: garbageWeight
        })
      }

      //DynamoDBに登録されている運行情報が6件未満の場合、空データを投入
      // for (let i = last_serviceCounts; i < this.REPORT_DETALE_COUNT; i++) {
      //   dirtObject_tmp.push({
      //     index: Number(i) + 1,
      //     collectionStartTime: "",
      //     collectionEndTime: "",
      //     collectionTime: "",
      //     stopTime: "",
      //     collectionPoints: null,
      //     collectionDistance: null,
      //     travelTime: "",
      //     travelDistance: null,
      //     garbageWeight: null
      //   })
      // }

      //小計データのフォーマット化
      totalCollectionTimeFormatted = this.getHourMinFormatFromMs(totalCollectionTimeMs)
      totalStopTimeFormatted = this.getHourMinFormatFromMs(totalStopTimeMs)
      totalTravelTimeFormatted = this.getHourMinFormatFromMs(totalTravelTimeMs)

      //表示データ
      this.l_reportDetailsData = {
        dataType: report.dataType,
        dataNo: report.dataNo,
        collectionDate: report.collectionDate,
        garbageCategory: report.garbageCategory,
        companyNumber: report.companyNumber,
        company: report.company,
        areaNo: report.areaNo,
        createAt: report.createAt,
        lastModifiedAt: new Date().toISOString().replace('T', ' ').substring(0, 19).replace(/-/g, '/'),
        targetNo: report.targetNo,
        driverName: report.driverName,
        collectionArea: report.collectionArea,
        operatorName: report.operatorName,
        registrationFlag: report.registrationFlag,
        dirtObject: dirtObject_tmp,
        totalCollectionStartTime: totalCollectionStartTimeFormatted,
        totalCollectionEndTime: totalCollectionEndTimeFormatted,
        totalCollectionTime: totalCollectionTimeFormatted,
        totalStopTime: totalStopTimeFormatted,
        totalCollectionPoints: totalCollectionPoints,
        totalCollectionDistance: Math.round(totalCollectionDistance*1000)/1000,
        totalTravelTime: totalTravelTimeFormatted,
        totalTravelDistance: Math.round(totalTravelDistance*1000)/1000,
        totalGarbageWeight: totalGarbageWeight,
        recollections: report.recollections,
        routeId: report.routeId,
        beforeServiceOdometer: report.beforeServiceOdometer,
        afterServiceOdometer: report.afterServiceOdometer,
        refuelingAmount: report.refuelingAmount
      }

      /*バリデーションの初期化*/
      for (let i = 0; i < this.l_reportDetailsData.dirtObject.length; i++) {
        this.collectionStartTimeState(i)
        this.collectionEndTimeState(i)
        this.collectionPointsState(i)
        this.collectionDistanceState(i)
        this.travelTimeState(i)
        this.travelDistanceState(i)
        this.garbageWeightState(i)
        this.recollectionsState(i)
        this.beforeServiceOdometerState(i)
        this.afterServiceOdometerState(i)
        this.refuelingAmountState(i)
      }

      //全体のバリデーション確認
      this.reportUpdateAvailabilityState()
      this.totalValidationView()

      //変更比較用データ
      this.l_reportDetailsDataComp = JSON.parse(JSON.stringify(this.l_reportDetailsData))
    },
    readReportDetails(){
      var collectionInfo=[]

      for (var index in this.l_reportDetailsData.dirtObject) {
        var dirt = this.l_reportDetailsData.dirtObject[index]

        //運行回の生成
        var serviceCounts_tmp = "0"
        var serviceCountsSub_tmp = "0"
        var dirt_index=String(dirt.index)
        if (dirt_index.includes(this.SERVICE_COUNT_CHAR)) {
          serviceCounts_tmp = dirt_index.split(this.SERVICE_COUNT_CHAR)[0]
          serviceCountsSub_tmp = dirt_index.split(this.SERVICE_COUNT_CHAR)[1]
        } else {
          serviceCounts_tmp = dirt_index
          serviceCountsSub_tmp = "0"
        }

        //開始時刻のISO化
        var collectionStartTime_tmp = ""
        if (dirt.collectionStartTime != "") {
          collectionStartTime_tmp = moment(this.l_reportDetailsData.collectionDate + " " + dirt.collectionStartTime).utc().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
        }

        //終了時刻のISO化
        var collectionEndTime_tmp = ""
        if (dirt.collectionEndTime != "") {
          collectionEndTime_tmp = moment(this.l_reportDetailsData.collectionDate + " " + dirt.collectionEndTime).utc().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
        }

        //登録用の収集情報オブジェクト配列の形成
        var dirtObject_tmp = {
          serviceCounts: Number(serviceCounts_tmp),
          serviceCountsSub: Number(serviceCountsSub_tmp),
          collectionStartTime: collectionStartTime_tmp,
          collectionEndTime: collectionEndTime_tmp,
          collectionTime: dirt.collectionTime,
          stopTime: dirt.stopTime,
          collectionPoints: Number(dirt.collectionPoints),
          collectionDistance: Number(dirt.collectionDistance),
          travelTime: dirt.travelTime,
          travelDistance: Number(dirt.travelDistance),
          garbageWeight: dirt.garbageWeight
        }

        collectionInfo.push(dirtObject_tmp)

      }
      return {
        dataType: this.l_reportDetailsData.dataType,
        dataNo: this.l_reportDetailsData.dataNo,
        targetNo: this.l_reportDetailsData.targetNo,
        collectionDate: this.l_reportDetailsData.collectionDate,
        routeId: this.l_reportDetailsData.routeId,
        createAt: this.l_reportDetailsData.createAt,
        lastModifiedAt: this.l_reportDetailsData.lastModifiedAt,
        garbageCategory: this.l_reportDetailsData.garbageCategory,
        driverName: this.l_reportDetailsData.driverName,
        operatorName: this.l_reportDetailsData.operatorName,
        company: this.l_reportDetailsData.company,
        companyNumber: Number(this.l_reportDetailsData.companyNumber),
        collectionArea: this.l_reportDetailsData.collectionArea,
        areaNo: this.l_reportDetailsData.areaNo,
        registrationFlag: this.l_reportDetailsData.registrationFlag,
        collectionInfo:collectionInfo,
        recollections: Number(this.l_reportDetailsData.recollections),
        beforeServiceOdometer: Number(this.l_reportDetailsData.beforeServiceOdometer),
        afterServiceOdometer: Number(this.l_reportDetailsData.afterServiceOdometer),
        refuelingAmount: Number(this.l_reportDetailsData.refuelingAmount)
      }
    },
    // NEW-68 methods
    async initCreateNewReportModal(mode) {
      this.l_createNew_selectd = mode
      this.$refs.CreateNewReportModal.show();

      if (mode == 'household') {
        this.l_household_vehicleoptions_createNew = this.getHouseReportVehicleOptions(this.l_household_companyIDs);
        this.l_householdReportTableData_createNew_LENGTH = 0
      } else {
        this.l_recycle_vehicleoptions_createNew = this.getRecycleReportVehicleOptions(this.l_recycle_companyIDs);
        this.l_recycleReportTableData_createNew_LENGTH = 0
      }
      this.l_reportDateState = false
      this.l_companyState = false
      this.l_typeState = false
      this.l_vehicleNoState = false
      this.l_createNewReportIndex = JSON.parse(JSON.stringify(this.l_createNewReportIndex_Original))
      this.l_createNewReportIndex.date = moment().format('YYYY-MM-DD')
      this.l_createNewReportIndex.garbageKindNo = (mode === 'household') ? '0' : ""
    },
    getCompanyNameFromId(optionArr, id) {
      const companyName = optionArr.filter(e => e.value == id)[0].text
      return companyName
    },
    getCompanyIdFronName(targetName) {
      var companylist = this.getCompanyOptions()
      const companyId = companylist.filter(e => e.text == targetName)[0].value
      return companyId
    },
    initEditModalParameters() {
      this.isCreateNew = false;
      this.l_reportUnsavedAlert = false;
      this.l_reportOverrideAlert = false;
      this.l_editHouseholdCompleted = false;
      this.l_editRecycleCompleted = false;
    },
    showEditReportModal: async function () {
      this.l_createnewProcessing = true

      this.l_createNewReportIndex.dataNo = this.l_createNewReportIndex.vehicleNo + '-' + this.l_createNewReportIndex.date.replaceAll('-', '') + '-' + this.l_createNewReportIndex.routeId
      if (this.l_createNew_selectd === 'household') {
        this.l_createNewReportIndex.companyName = this.getCompanyNameFromId(this.l_household_companyoptions, this.l_createNewReportIndex.companyId)
        await this.getHouseholdDailyReportWorkRequestWrapper()
        if (this.l_householdReportTableData_createNew_LENGTH === 0) {
          var argReport = JSON.parse(JSON.stringify(this.getReportTemplate()))
          argReport['dataNo'] = this.l_createNewReportIndex.dataNo
          argReport['garbageKindNo'] = this.l_createNewReportIndex.garbageKindNo
          argReport['targetNo'] = this.l_createNewReportIndex.vehicleNo
          argReport['collectionDate'] = this.l_createNewReportIndex.date.replaceAll('-', '/')
          argReport['routeId'] = this.l_createNewReportIndex.routeId
          argReport['companyNumber'] = String(this.l_createNewReportIndex.companyId - 1)
          argReport['company'] = this.l_createNewReportIndex.companyName

          this.storeReportDetails({ 'report': argReport, 'classification': [] })
          this.l_onlyBrowse = false;
          this.$refs.CreateNewReportModal.hide();
          this.$refs.editHouseholdModal.show();
        } else {
          // 検索実行画面表示
          this.l_household_start_dateselected = this.l_createNewReportIndex.date
          this.l_household_end_dateselected = this.l_createNewReportIndex.date
          this.l_household_companyselected = this.l_createNewReportIndex.companyId
          this.l_household_vehicleselected = this.l_createNewReportIndex.vehicleNo
          this.l_household_routeselected = this.l_createNewReportIndex.routeId
          this.handleHouseholdCompanySelected(this.l_createNewReportIndex.companyId)
          this.isCreateNew = false
          this.$refs.CreateNewReportModal.hide();
        }
      }
      this.l_createnewProcessing = false
    },


    handleCompanySelected(event) {
      if (this.l_createNew_selectd === 'household') {
        this.l_household_vehicleoptions_createNew = this.getHouseReportVehicleOptions([event])
      } else {
        this.l_recycle_vehicleoptions_createNew = this.getRecycleReportVehicleOptions([event])
      }
    },

    handleHouseholdCompanySelected(event) {
      this.l_household_vehicleoptions = this.getHouseReportVehicleOptions([event])
      const carNoArr = this.l_household_vehicleoptions.map(e => e.value)
      if (!carNoArr.includes(this.l_household_vehicleselected)) this.l_household_vehicleselected = ''
    },
    handleRecycleCompanySelected(event) {
      this.l_recycle_vehicleoptions = this.getRecycleReportVehicleOptions([event])
      const carNoArr = this.l_recycle_vehicleoptions.map(e => e.value)
      if (!carNoArr.includes(this.l_recycle_vehicleselected)) this.l_recycle_vehicleselected = ''
    },

    handleCancelClick() {
      if (this.isReportDetailsUpdated()) {
        this.l_reportUnsavedAlert = true
      } else {
        this.cancel()
      }
    },

    isReportDetailsUpdated() {
      return !(
        (JSON.stringify(Object.entries(this.l_reportDetailsDataComp).sort()) === JSON.stringify(Object.entries(this.l_reportDetailsData).sort()))
      )
    },

    cancel() {
      this.$refs.editHouseholdModal.hide();
    },
    getGarbagedayType(garbageKindNo, targetDate) {
      let garbagedayType = '999'
      let dayArea = '不明'

      // getDay(): 月曜日:1 → 0
      let targetDay = String(new Date(targetDate).getDay() - 1)
      if (garbageKindNo == undefined || garbageKindNo == "") { garbagedayType = '999' }
      else if (garbageKindNo == '0') {
        if (['0', '1', '3', '4'].includes(targetDay)) {
          garbagedayType = '0'
        }
        else if (targetDay == '2') {
          let checkDate = new Date(targetDate).getDate()
          if (7 >= checkDate && checkDate >= 1) { garbagedayType = '1' }
          else if (14 >= checkDate && checkDate >= 8) { garbagedayType = '2' }
          else if (21 >= checkDate && checkDate >= 15) { garbagedayType = '3' }
        }
      }
      else if (garbageKindNo == '1') {
        let testDate = targetDate.replaceAll('-', '')
        let dayInformation1 = this.l_recycleCollectionInformation.filter(e => (e.weekday == targetDay && e.garbagedayType == '1'))[0]
        let dayInformation2 = this.l_recycleCollectionInformation.filter(e => (e.weekday == targetDay && e.garbagedayType == '2'))[0]
        if (dayInformation1 != undefined && dayInformation1['garbageDate'].length > 0 && dayInformation1['garbageDate'].includes(testDate)) {
          garbagedayType = '1'
          dayArea = dayInformation1['garbageArea']
        }
        else if (dayInformation2 != undefined && dayInformation2['garbageDate'].length > 0 && dayInformation2['garbageDate'].includes(testDate)) {
          garbagedayType = '2'
          dayArea = dayInformation2['garbageArea']
        }
      }
      else if (garbageKindNo == '2') {
        let testDate = targetDate.replaceAll('-', '')
        let dayInformation1 = this.l_recycleInstallationInformation.filter(e => (e.weekday == targetDay && e.garbagedayType == '1'))[0]
        let dayInformation2 = this.l_recycleInstallationInformation.filter(e => (e.weekday == targetDay && e.garbagedayType == '2'))[0]
        if (dayInformation1 != undefined && dayInformation1['garbageDate'].length > 0 && dayInformation1['garbageDate'].includes(testDate)) {
          garbagedayType = '1'
          dayArea = dayInformation1['garbageArea']
        }
        else if (dayInformation2 != undefined && dayInformation2['garbageDate'].length > 0 && dayInformation2['garbageDate'].includes(testDate)) {
          garbagedayType = '2'
          dayArea = dayInformation2['garbageArea']
        }
      }
      return { garbagedayType: garbagedayType, garbageArea: dayArea }
    },
    getRecycleGarbageInformation: async function () {
      this.l_getGarbageInformationProcessing = true
      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
        }
      };
      await axios.get(this.createAPI("adminreports/recyclablegarbageinformationrequest"), reqdata)
        .then(response => {
          this.l_recycleCollectionInformation = response.data.recyclableGarbageInformation.filter(e => e.garbageKindNo == '1')
          this.l_recycleInstallationInformation = response.data.recyclableGarbageInformation.filter(e => e.garbageKindNo == '2')
        })
        .catch(error => {
          this.l_reportListSearchRequestOfHousehold = false
          var title = "日程情報"
          var msg = "日程情報の取得に失敗しました。"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
      this.l_getGarbageInformationProcessing = false
    },
    // Interface Wrapper
    // householdDailyReport_WorkRequest
    getHouseholdDailyReportWorkRequestWrapper: async function (id) {
      if (!this.isCreateNew) this.l_reportListSearchRequestOfHousehold = true
      const collectDateStart = this.isCreateNew ? this.l_createNewReportIndex.date.replaceAll('-', '/') : this.l_household_start_dateselected.replaceAll('-', '/')
      const collectDateEnd = this.isCreateNew ? this.l_createNewReportIndex.date.replaceAll('-', '/') : this.l_household_end_dateselected.replaceAll('-', '/')
      const vehicleId = this.isCreateNew ? this.l_createNewReportIndex.vehicleNo : this.l_household_vehicleselected
      const companyId = this.isCreateNew ? '' : this.l_household_companyselected
      const routeId = this.isCreateNew ? this.l_createNewReportIndex.routeId : this.l_household_routeselected

      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          collectDateStart: collectDateStart,
          collectDateEnd: collectDateEnd,
          vehicleId: vehicleId,
          companyId: companyId,
          routeId: routeId,
        }
      };
      await axios.get(this.createAPI("adminreports/householddailyreport_workrequest"), reqdata)
        .then(response => {
          this.l_reportListSearchRequestOfHousehold = false
          var list = []
          for (var i in response.data.householdDaily) {
            var date = response.data.householdDaily[i].collectDate
            var companyname = response.data.householdDaily[i].companyName
            var vehicleid = response.data.householdDaily[i].vehicleId
            var routeid = response.data.householdDaily[i].routeId
            var activestatus = this.isActiveVehicle(date, companyname, vehicleid, routeid)
            list.push({
              '作業日': response.data.householdDaily[i].collectDate,
              '車両番号': response.data.householdDaily[i].vehicleId,
              //'企業ID' : response.data.householdDaily[i].companyNumber,
              '企業名': response.data.householdDaily[i].companyName,
              'ルートID': response.data.householdDaily[i].routeId,
              '承認': (response.data.householdDaily[i].isApproved == '1') ? true : false,
              '稼働中': activestatus
            })
          }
          if (!this.isCreateNew) {
            this.l_householdReportTableData = list
            this.l_updateHouseholdIndex = []
          } else {
            if (list.length !== 0) {
              this.l_householdReportTableData = list;
              this.l_updateHouseholdIndex = []
            }
            this.l_householdReportTableData_createNew_LENGTH = list.length
          }
          if (list.length == 0) {
            if (!this.isCreateNew) {
              var title = "レポート検索結果(家庭ごみ)"
              var msg = "レポートが見つかりませんでした"
              this.showErrorMessageToast(
                title,
                msg,
                'info'
              );
            }
          } else {
            var title = "レポート検索結果(家庭ごみ)"
            var msg = list.length + " 件のレポートが見つかりました"
            this.showErrorMessageToast(
              title,
              msg,
              'info'
            );
          }
        })
        .catch(error => {
          this.l_reportListSearchRequestOfHousehold = false
          var title = "レポート検索エラー"
          var msg = "レポートが見つかりませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    // dailyReport 承認
    postHouseholdDailyReportWorkUpdateWrapper: async function (index) {
      this.l_updateHouseholdIndex.push(index)
      var item = this.l_householdReportTableData[index]
      const hdrdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
      };
      const paramdata = {
        collectDate: item['作業日'],
        vehicleId: item['車両番号'],
        routeId: item['ルートID'],
        updatedata: { isApproved: (item['承認']) ? '0' : '1' }
      };
      await axios.post(this.createAPI("adminreports/householddailyreport_workupdaterequest"), paramdata, hdrdata)
        .then(response => {
          if (response.data.message) {
            item['承認'] = !item['承認']
          } else {
            var title = "承認データ更新エラー"
            var msg = "承認データの更新情報が間違っています"
            this.showErrorMessageToast(
              title,
              msg,
              'danger'
            );
          }
        })
        .catch(error => {
          var title = "承認データ更新エラー"
          var msg = "承認データの更新に失敗しました"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
      this.l_updateHouseholdIndex.splice(this.l_updateHouseholdIndex.indexOf(index), 1)
    },

    // dailyReport 削除
    dailyReportDeleteWrapper: async function (index) {
      this.l_deleteReportProcessing = true
      if (this.l_report_garbageType == 'household') {
        var item = this.l_householdReportTableData[index]
        await this.postHouseholdDailyReportDeleteWrapper(index, item)
      } else {
        let item = this.l_recycleReportTableData[index]
        //        await Promise.all([this.postRecyclableDailyReportDeleteWrapper(index, item),
        //                           this.postRecyclableDailyReportDeleteStationWrapper(item)])
        await this.postRecyclableDailyReportDeleteWrapper(index, item)
      }
      this.l_deleteReportProcessing = false
    },

    postHouseholdDailyReportDeleteWrapper: async function (index, item) {

      var reportNo = item['車両番号']+"-"+item['作業日'].replaceAll("/", "")+"-"+item['ルートID']
      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          reportDataNo: reportNo,
          stage:process.env.VITE_API_STAGE
        }
      };

      await axios.delete(this.createInternalAPI("report/detail"), reqdata)
        .then(response => {

          if (response.data.body.message) {
            this.l_householdReportTableData.splice(index, 1)
            this.l_deleteReportCompleted = true
          } else {
            var title = "日報データ削除エラー"
            var msg = "日報データの削除情報が間違っています"
            this.showErrorMessageToast(
              title,
              msg,
              'danger'
            );
          }
        })
        .catch(error => {
          var title = "日報データ削除エラー"
          var msg = "日報データの削除に失敗しました"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    // 編集用データ取得
    getDailyReportDetailsWrapper: async function (event) {
      this.l_reportDetailsLoading = true
      this.l_onlyBrowse = this.isCreateNew ? false : event.item['承認'];

      var reportNo = this.isCreateNew ? event.dataNo :
                                        event.item['車両番号']+"-"+event.item['作業日'].replaceAll("/", "")+"-"+event.item['ルートID']

      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          reportDataNo: reportNo,
          stage:process.env.VITE_API_STAGE
        }
      };
      console.log("createAPI",this.createInternalAPI("report/detail"))
      await axios.get(this.createInternalAPI("report/detail"), reqdata)
        .then(response => {
          this.l_reportDetailsLoading = false
          this.l_editHouseholdProcessing = false
          this.l_editHouseholdCompleted = false
          this.l_editRecycleProcessing = false
          this.l_editRecycleCompleted = false
          if (this.isCreateNew) {
            // 新規作成のため、report は存在しない
            //                classificationのみAPIで取得
            var argReport = JSON.parse(JSON.stringify(this.getReportTemplate()))
            argReport['dataNo'] = this.l_createNewReportIndex.dataNo
            argReport['garbageKindNo'] = this.l_createNewReportIndex.garbageKindNo
            argReport['targetNo'] = this.l_createNewReportIndex.vehicleNo
            argReport['collectionDate'] = this.l_createNewReportIndex.date.replaceAll('-', '/')
            argReport['routeId'] = this.l_createNewReportIndex.routeId
            argReport['companyNumber'] = String(this.l_createNewReportIndex.companyId - 1)
            argReport['company'] = this.l_createNewReportIndex.companyName
            let collectionInformation = this.getGarbagedayType(this.l_createNewReportIndex.garbageKindNo, this.l_createNewReportIndex.date)
            argReport['collectionArea'] = collectionInformation['garbageArea']
            response.data.body.report = argReport
          }
          this.storeReportDetails(response.data.body)
          this.$refs.editHouseholdModal.show();

        })
        .catch(error => {
          this.l_reportDetailsLoading = false

          var title = "レポート詳細取得エラー"
          var msg = "レポート詳細が見つかりませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    updateDailyReportDetailsWrapper() {
      this.l_editHouseholdProcessing = true
      this.l_editRecycleProcessing = true

      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          report: this.readReportDetails(),
          stage:process.env.VITE_API_STAGE
        }
      };
      axios.post(this.createInternalAPI("report/detail"), reqdata)
        .then(response => {
          this.l_editHouseholdProcessing = false
          this.l_editHouseholdCompleted = true
          this.l_editRecycleProcessing = false
          this.l_editRecycleCompleted = true
        })
        .catch(error => {
          this.l_editHouseholdProcessing = false
          this.l_editHouseholdCompleted = true
          this.l_editRecycleProcessing = false
          this.l_editRecycleCompleted = true
          var title = "レポート詳細更新エラー"
          var msg = "レポート詳細が更新できませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    getReportCommentData(date, garbageType) {
      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          collectionDate: date,
          garbageType: garbageType,
        }
      };
      axios.get(this.createInternalAPI("report/comment"), reqdata)
        .then(response => {
          if (response.data.body.garbageType == "0") {
            this.l_householdCommentData = response.data.body.msg
            this.l_overlay_household_dailysummary = false
          } else if (response.data.body.garbageType == "1") {
            this.l_recycleCollectionCommentData = response.data.body.msg
            this.l_overlay_recycle_dailysummary = false
          } else {
            this.l_recycleInstallationCommentData = response.data.body.msg
            this.l_overlay_recycle_dailysummary = false
          }
        })
        .catch(error => {

          this.l_overlay_household_dailysummary = false
          var title = "巡回指導内容取得エラー"
          var msg = "巡回指導内容が取得できませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    updateReportCommentData(garbageType) {
      var date = ""
      var msg = ""
      if (garbageType == "0") {
        date = this.l_currentHouseholdDashboardDate
        msg = this.l_householdCommentData
      } else if (garbageType == "1") {
        date = this.l_currentRecycleCollectionDashboardDate
        msg = this.l_recycleCollectionCommentData
      } else {
        date = this.l_currentRecycleInstallationDashboardDate
        msg = this.l_recycleInstallationCommentData
      }
      date = date.replaceAll("-", "/")
      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          collectionDate: date,
          garbageType: garbageType,
          msg: msg
        }
      };
      axios.post(this.createInternalAPI("report/comment"), reqdata)
        .then(response => {
          var title = "巡回指導内容"
          var msg = "コメントを更新しました"
          this.showErrorMessageToast(
            title,
            msg,
            'info'
          );
        })
        .catch(error => {

          var title = "巡回指導内容更新エラー"
          var msg = "巡回指導内容が更新できませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
    },
    initEditHouseHoldStartDate() {
      if (this.l_household_end_dateselected < this.l_household_start_dateselected) {
        this.l_household_end_dateselected = this.l_household_start_dateselected
      }
    },
    dateDisabledHouseHoldEdit(ymd, date) {
      var startDate = new Date(this.l_household_start_dateselected)
      startDate.setDate(startDate.getDate() - 1)
      return date < startDate
    },

    /*運行情報の変更時処理*/
    collectionStartTimeInput(index) {
      //小計_開始の変更
      var collectionStartTime_tmp = this.l_reportDetailsData.dirtObject[index].collectionStartTime
      if (index == 0) {
        this.l_reportDetailsData.totalCollectionStartTime = collectionStartTime_tmp
      }
      this.collectionTimeInput(index)

      //全体のバリデーション確認
      this.collectionStartTimeState(index)
      this.collectionEndTimeState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()

    },
    collectionEndTimeInput(index) {
      //小計_終了の変更
      for (var i = 0; i < this.l_reportDetailsData.dirtObject.length; i++) {
        var collectionEndTime_tmp = this.l_reportDetailsData.dirtObject[i].collectionEndTime
        if (collectionEndTime_tmp != "") {
          this.l_reportDetailsData.totalCollectionEndTime = collectionEndTime_tmp
        }
      }
      this.collectionTimeInput(index)

      //全体のバリデーション確認
      this.collectionStartTimeState(index)
      this.collectionEndTimeState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()
    },

    collectionTimeInput(index) {
      //収集時間及び小計_収集時間の変更

      //収集時間の変更
      var collectionStartTime_tmp = this.l_reportDetailsData.dirtObject[index].collectionStartTime
      var collectionEndTime_tmp = this.l_reportDetailsData.dirtObject[index].collectionEndTime

      var collectionTimeMs = 0
      var collectionTimeFormatted = "00:00"
      if (collectionEndTime_tmp != "" && collectionStartTime_tmp != "") {
        collectionTimeMs = moment(collectionEndTime_tmp, 'HH:mm').diff(moment(collectionStartTime_tmp, 'HH:mm'))
        collectionTimeFormatted = this.getHourMinFormatFromMs(collectionTimeMs)
      }
      this.l_reportDetailsData.dirtObject[index].collectionTime = collectionTimeFormatted

      //小計_収集時間の変更
      var totalCollectionTimeMs = 0
      var totalCollectionTimeFormatted = "00:00"
      for (var i in this.l_reportDetailsData.dirtObject) {
        var collectionTime = this.l_reportDetailsData.dirtObject[i].collectionTime
        if (collectionTime != "") {
          collectionTimeMs = moment(collectionTime, 'HH:mm').diff(moment(totalCollectionTimeFormatted, 'HH:mm'))
          totalCollectionTimeMs = totalCollectionTimeMs + collectionTimeMs
        }

      }
      this.l_reportDetailsData.totalCollectionTime = this.getHourMinFormatFromMs(totalCollectionTimeMs)

    },
    collectionPointsInput(index) {
      // 収集集積所の変更
      var totalCollectionPoints = 0
      for (var i in this.l_reportDetailsData.dirtObject) {
        var collectionPoints = Number(this.l_reportDetailsData.dirtObject[i].collectionPoints)
        if (collectionPoints != "") {
          totalCollectionPoints = totalCollectionPoints + collectionPoints
        }
      }
      this.l_reportDetailsData.totalCollectionPoints = totalCollectionPoints

      //全体のバリデーション確認
      this.collectionPointsState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()
    },
    collectionDistanceInput(index) {
      // 収集距離の変更
      var totalCollectionDistance = 0
      for (var i in this.l_reportDetailsData.dirtObject) {
        var collectionDistance = Number(this.l_reportDetailsData.dirtObject[i].collectionDistance)
        if (collectionDistance != "") {
          totalCollectionDistance = totalCollectionDistance + collectionDistance
        }
      }
      this.l_reportDetailsData.totalCollectionDistance = totalCollectionDistance

      //全体のバリデーション確認
      this.collectionDistanceState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()
    },
    travelTimeInput(index) {
      //ごみ捨て時間の変更
      var totalTravelTimeMs = 0
      var totalTravelTimeFormatted = "00:00"
      for (var i in this.l_reportDetailsData.dirtObject) {
        var travelTime = this.l_reportDetailsData.dirtObject[i].travelTime
        if (travelTime != "") {
          var travelTimeMs = moment(travelTime, 'HH:mm').diff(moment(totalTravelTimeFormatted, 'HH:mm'))
          totalTravelTimeMs = totalTravelTimeMs + travelTimeMs
        }

      }
      this.l_reportDetailsData.totalTravelTime = this.getHourMinFormatFromMs(totalTravelTimeMs)

      //全体のバリデーション確認
      this.travelTimeState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()
    },
    travelDistanceInput(index) {
      // ごみ捨て距離の変更
      var totalTravelDistance = 0
      for (var i in this.l_reportDetailsData.dirtObject) {
        var travelDistance = Number(this.l_reportDetailsData.dirtObject[i].travelDistance)
        if (travelDistance != "") {
          totalTravelDistance = totalTravelDistance + travelDistance
        }
      }
      this.l_reportDetailsData.totalTravelDistance = totalTravelDistance

      //全体のバリデーション確認
      this.travelDistanceState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()
    },
    garbageWeightInput(index) {
      // ごみ量の変更
      var totalGarbageWeight = 0
      for (var i in this.l_reportDetailsData.dirtObject) {
        var garbageWeight = Number(this.l_reportDetailsData.dirtObject[i].garbageWeight)
        if (garbageWeight != "") {
          totalGarbageWeight = totalGarbageWeight + garbageWeight
        }
      }
      this.l_reportDetailsData.totalGarbageWeight = totalGarbageWeight

      //全体のバリデーション確認
      this.garbageWeightState(index)
      this.reportUpdateAvailabilityState()
      this.totalValidationView()

    },
    // 再収集回数の入力ハンドラ
    recollectionsInput() {
      // ユーザー入力値を数値型に変換（parseFloatやNumberで明示的に変換）
      const rawValue = this.l_reportDetailsData.recollections;
      const convertedValue = Number(rawValue);

      // 入力値が数値として有効かどうかをチェック
      if (isNaN(convertedValue)) {
        // エラーハンドリング：入力値が数値でない場合は無効フラグを設定
        this.l_recollectionsValidation = false;
      } else {
        // 変換後の値をモデルへ反映し、正規の検証関数を実行
        this.l_reportDetailsData.recollections = convertedValue;
        this.recollectionsState();
      }

      // 更新可能状態と全体バリデーション一覧の再評価
      this.reportUpdateAvailabilityState();
      this.totalValidationView();
    },

    // ODO運行前の入力ハンドラ
    beforeServiceOdometerInput() {
      const rawValue = this.l_reportDetailsData.beforeServiceOdometer;
      const convertedValue = Number(rawValue);

      if (isNaN(convertedValue)) {
        this.l_beforeServiceOdometerValidation = false;
      } else {
        this.l_reportDetailsData.beforeServiceOdometer = convertedValue;
        this.beforeServiceOdometerState();
        this.afterServiceOdometerState(); // ここでafterの検証も
      }

      this.reportUpdateAvailabilityState();
      this.totalValidationView();
    },

    // ODO運行後の入力ハンドラ
    afterServiceOdometerInput() {
      const rawValue = this.l_reportDetailsData.afterServiceOdometer;
      const convertedValue = Number(rawValue);

      if (isNaN(convertedValue)) {
        this.l_afterServiceOdometerValidation = false;
      } else {
        this.l_reportDetailsData.afterServiceOdometer = convertedValue;
        this.afterServiceOdometerState();
      }

      this.reportUpdateAvailabilityState();
      this.totalValidationView();
    },

    // 給油量の入力ハンドラ
    refuelingAmountInput() {
      const rawValue = this.l_reportDetailsData.refuelingAmount;
      const convertedValue = Number(rawValue);

      if (isNaN(convertedValue)) {
        this.l_refuelingAmountValidation = false;
      } else {
        this.l_reportDetailsData.refuelingAmount = convertedValue;
        this.refuelingAmountState();
      }

      this.reportUpdateAvailabilityState();
      this.totalValidationView();
    },

    /*運行情報のバリデーションチェック */
    collectionStartTimeState(index) {
      /*開始*/
      var collectionStartTime_tmp = this.l_reportDetailsData.dirtObject[index].collectionStartTime
      var collectionEndTime_tmp = this.l_reportDetailsData.dirtObject[index].collectionEndTime

      //開始＜＝終了（正常）
      //空欄（未選択）&& 終了選択 または 開始＞終了（不正）
      if (collectionStartTime_tmp != "" && collectionEndTime_tmp != "") {
        this.l_collectionStartTimeValidation[index] = !moment(collectionEndTime_tmp, "HH:mm").isBefore(moment(collectionStartTime_tmp, "HH:mm"))
      } else if (collectionStartTime_tmp == "" && collectionEndTime_tmp != "") {
        this.l_collectionStartTimeValidation[index] = false
      }else if (collectionStartTime_tmp != "" && collectionEndTime_tmp == "") {
        this.l_collectionStartTimeValidation[index] = true
      }else if (collectionStartTime_tmp == "" && collectionEndTime_tmp == "") {
        this.l_collectionStartTimeValidation[index] = true
      }
      return this.l_collectionStartTimeValidation[index]
    },
    collectionEndTimeState(index) {
      /*終了#開始と同様*/
      this.l_collectionEndTimeValidation[index]=this.collectionStartTimeState(index)
      return this.l_collectionEndTimeValidation[index]
    },
    collectionPointsState(index) {
      /*集積所*/
      var collectionPoints_tmp = Number(this.l_reportDetailsData.dirtObject[index].collectionPoints)
      //0 以上 999 以下の整数
      if (collectionPoints_tmp >= 0 && collectionPoints_tmp < 1000 && this.isInteger(collectionPoints_tmp)) {
        this.l_collectionPointsValidation[index] = true
      } else {
        this.l_collectionPointsValidation[index] = false
      }
      return this.l_collectionPointsValidation[index]
    },
    collectionDistanceState(index){
      /*収集距離*/
      var collectionDistance_tmp = Number(this.l_reportDetailsData.dirtObject[index].collectionDistance)
            //0 以上 999.9 以下の数
      if (collectionDistance_tmp >= 0 && collectionDistance_tmp <= 1000 && this.isDecimal(collectionDistance_tmp)) {
        this.l_collectionDistanceValidation[index] = true
      } else {
        this.l_collectionDistanceValidation[index] = false
      }
      return this.l_collectionDistanceValidation[index]
    },
    travelTimeState(index) {
      return this.l_travelTimeValidation[index] = true
    },
    travelDistanceState(index){
      /*ごみ捨て距離*/
      var travelDistance_tmp = Number(this.l_reportDetailsData.dirtObject[index].travelDistance)
            //0 以上 999.9 以下の数
      if (travelDistance_tmp >= 0 && travelDistance_tmp < 1000 && this.isDecimal(travelDistance_tmp)) {
        this.l_travelDistanceValidation[index] = true
      } else {
        this.l_travelDistanceValidation[index] = false
      }
      return this.l_travelDistanceValidation[index]
    },
    garbageWeightState(index){
      /*ごみ量*/
      var garbageWeight_tmp = Number(this.l_reportDetailsData.dirtObject[index].garbageWeight)

      //ごみ積載制限一覧の取得
      var payload = this.MAX_GARBAGE_WEIGHT
      var capList = this.getLoadingCapacity()
      for (var cap in capList) {
        if (capList[cap].carNo == this.l_reportDetailsData.targetNo) {
          payload = capList[cap].payLoad
        }
      }

      //0 以上 9999 以下の整数
      if (garbageWeight_tmp >= 0 && garbageWeight_tmp < 10000 && this.isInteger(garbageWeight_tmp)) {
        this.l_garbageWeightValidation[index] = true
      } else {
        this.l_garbageWeightValidation[index] = false
      }
      return this.l_garbageWeightValidation[index]
    },
    recollectionsState(){
      /*再収集回数*/
      var recollections_tmp = Number(this.l_reportDetailsData.recollections)
      //0 以上 99 以下の整数
      if (recollections_tmp >= 0 && recollections_tmp < 100 && this.isInteger(recollections_tmp)) {
        this.l_recollectionsValidation = true
      } else {
        this.l_recollectionsValidation = false
      }
      return this.l_recollectionsValidation
    },
    beforeServiceOdometerState() {
      /* ODO運行前（km）の検証 */
      var beforeOdo = Number(this.l_reportDetailsData.beforeServiceOdometer)
      // NaNチェックと、0以上かつ整数であることを確認
      if (beforeOdo >= 0 && beforeOdo < 1000000.0) {
        this.l_beforeServiceOdometerValidation = true
      } else {
        this.l_beforeServiceOdometerValidation = false
      }
      return this.l_beforeServiceOdometerValidation
    },
    afterServiceOdometerState() {
      /* ODO運行後（km）の検証 */
      var afterOdo = Number(this.l_reportDetailsData.afterServiceOdometer)
      var beforeOdo = Number(this.l_reportDetailsData.beforeServiceOdometer)
      // NaNチェックと0以上かつ整数であることを確認
      if (afterOdo >= 0 && afterOdo < 1000000.0) {
        // 運行後の値はそれ以上でなければならない
        if (afterOdo >= beforeOdo) {
          this.l_afterServiceOdometerValidation = true
        } else {
          this.l_afterServiceOdometerValidation = false
        }
      } else {
        this.l_afterServiceOdometerValidation = false
      }
      return this.l_afterServiceOdometerValidation
    },
    refuelingAmountState() {
      /* 給油量（l）の検証 */
      var fuelAmount = Number(this.l_reportDetailsData.refuelingAmount)
      // 給油量は0以上の数値であれば有効。（小数も許容）
      if (fuelAmount >= 0 && fuelAmount < 1000) {
        this.l_refuelingAmountValidation = true
      } else {
        this.l_refuelingAmountValidation = false
      }
      return this.l_refuelingAmountValidation
    },
    reportUpdateAvailabilityState() {
      for (let i = 0; i < this.l_reportDetailsData.dirtObject.length; i++) {
        if (this.l_collectionStartTimeValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_collectionEndTimeValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_collectionPointsValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_collectionDistanceValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_travelTimeValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_travelDistanceValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
        if (this.l_garbageWeightValidation[i] == false) {
          return this.l_reportUpdateAvailability=false
        }
      }
      if (this.l_recollectionsValidation == false) {
        return this.l_reportUpdateAvailability=false
      }
      if (this.l_beforeServiceOdometerValidation == false) {
        return this.l_reportUpdateAvailability=false
      }
      if (this.l_afterServiceOdometerValidation == false) {
        return this.l_reportUpdateAvailability=false
      }
      if (this.l_refuelingAmountValidation == false) {
        return this.l_reportUpdateAvailability=false
      }
      return this.l_reportUpdateAvailability=true
    },
    totalValidationView() {
      this.l_totalValidationView=[]
      for (let i = 0; i < this.l_reportDetailsData.dirtObject.length; i++) {
        if (this.l_collectionStartTimeValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目開始時刻")
        }
        if (this.l_collectionEndTimeValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目終了時刻")
        }
        if (this.l_collectionPointsValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目集積所")
        }
        if (this.l_collectionDistanceValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目収集距離")
        }
        if (this.l_travelTimeValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目ごみ捨て時間")
        }
        if (this.l_travelDistanceValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目ごみ捨て距離")
        }
        if (this.l_garbageWeightValidation[i] == false) {
          this.l_totalValidationView.push(this.l_reportDetailsData.dirtObject[i].index + "回目ごみ量")
        }
      }
      if (this.l_recollectionsValidation == false) {
        this.l_totalValidationView.push("再収集回数")
      }
      if (this.l_beforeServiceOdometerValidation == false) {
        this.l_totalValidationView.push("ODO運行前")
      }
      if (this.l_afterServiceOdometerValidation == false) {
        this.l_totalValidationView.push("ODO運行後")
      }
      if (this.l_refuelingAmountValidation == false) {
        this.l_totalValidationView.push("給油量")
      }
    },
    navigateToSummary() {
      this.$router.push('/report/summary');
    }
  }
}
</script>

<style scoped>
.editmodal {
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.form-control {
  text-align: left;
}

.nospin::-webkit-outer-spin-button,
.nospin::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.reportButton {
  text-align: right;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.report-area {
  height: 557px;
  width: 1500px;
  grid-area: content;
  overflow-y :scroll;
}

:deep(.report-table) {
  margin-bottom: 0px;
}

:deep(.report-table > thead) {
  position: sticky;
  top: 0;
  background-color: white;
  color: black;
  z-index: 10;
}

:deep(.report-table > tfoot) {
  position: sticky;
  bottom: 0;
  background-color: white;
  color: black;
  z-index: 10;
}
</style>

